import { request, proto } from '../main'
import { mappingFailureRecordCount, getDataAlertCount } from './egame/game'

/**
 * 获取未处理的购买意愿数量
 *
 * @return {PBIntValue}
 */
export function getPurchaseIntentionUnprocessCount () {
  const ALL = -1
  const pbReq = proto.create('framework.PBIntValue', {
    value: Number(ALL)
  })
  return request('fw.userPurchaseIntentionUnprocessCount', pbReq, 'PBIntValue')
}

/**
 * 获取未处理的企业认证数量
 *
 * @return {PBIntValue}
 */
export function getEnterproseAuthUncheckCount () {
  return request('fw.userEnterpriseAuthUncheckCount', null, 'PBIntValue')
}

/**
 * 后台开通服务列表待处理任务数量
 *
 * @return {PBIntValue}
 */
export function getConfigListUncheckCount () {
  return request('fw.userConfigListUnprocessCount', null, 'PBIntValue')
}

/**
 * 获取待审核续费任务数量
 *
 * @return {PBIntValue}
 */
export function getRenewalPendingCount () {
  return request('fw.renewalPendingCount', null, 'PBIntValue')
}

/**
 * 待审核的开票资料数量
 *
 * @return {PBIntValue}
 */
export function getCustomerBillInfoPendingCount () {
  return request('fw.customerBillInfoPendingCount', null, 'PBIntValue')
}

/**
 * 待审核的发票数量
 *
 * @return {PBIntValue}
 */
export function getInvoicePendingCount () {
  return request('fw.invoicePendingCount', null, 'PBIntValue')
}

/**
 * 失败通知的数量
 *
 * @return {PBIntValue}
 */
export function getNoticeCount () {
  return request('fw.noticeNumber', null, 'PBIntValue')
}

/**
 * 获取咨询报价待处理数量
 *
 * @return {PBIntValue}
 */
export function advisoryGetNum () {
  return request('fw.advisoryGetNum', null, 'PBIntValue')
}

// 消息未读数管理（红点管理）
export function getAllUncheckCount () {
  const auth = getEnterproseAuthUncheckCount()
  const intention = getPurchaseIntentionUnprocessCount()
  const config = getConfigListUncheckCount()
  const pending = getRenewalPendingCount()
  const bill = getCustomerBillInfoPendingCount()
  const invoice = getInvoicePendingCount()
  const notice = getNoticeCount()
  const countMappingFailure = mappingFailureRecordCount()
  // todo
  const dataAlertReq = getDataAlertCount()
  const advisory = advisoryGetNum()
  return Promise.all([auth, intention, config, pending, bill, invoice, notice, countMappingFailure, advisory, dataAlertReq]).then(result => {
    const _tempAlertList = result[9].list
    const dataAlertCount = _tempAlertList.reduce((total, curr) => {
      return total + Number(curr.count)
    }, 0)

    return {
      'auth-list': result[0].value,
      'business-list': result[1].value,
      'service-provision': result[2].value,
      'customer-renewal-management': result[3].value,
      'bill-info-management': result[4].value,
      'invoice-management': result[5].value,
      'customer-management': result[0].value + result[1].value + result[2].value + result[8].value,
      'fw-business': result[0].value + result[1].value + result[2].value + result[8].value,
      'finance-manangement': result[3].value + result[4].value + result[5].value,
      common: result[6].value,
      'common-notice': result[6].value,
      'electronic-sport-data-panel': result[7].value + dataAlertCount,
      // todo 添加数据异常统计
      'electronic-sport-data-management': dataAlertCount,
      'electronic-sport-data-abnormal-management': result[7].value,
      'advisory-list': result[8].value
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/app.js